import React, { useState, useEffect } from "react";
import '../css/tentangKami.css';
import data from '../data/visi-tentang.json';
import Ticker from "../components/ticker";
import StunningCard from "../components/stunnig-card";

export default function TentangKami() {
    const [jsonData, setJsonData] = useState([]);

    useEffect(() => {
        setJsonData(data);
    }, []);

    return (
        <>
            <section className="cover">
                <div className="tentang">
                    <h1>Tentang kami</h1>
                    <h2>
                        <span>
                            SMA Laboratorium
                        </span>
                        merupakan salah satu sekolah laboratorium yang berada dalam naungan Universitas Negeri Malang (d.h. IKIP Negeri Malang).
                    </h2>
                </div>
                <div className="visi">
                    <h1>
                        Visi kami menjadi lembaga pendidikan pencetak lulusan unggul yang;
                    </h1>
                </div>
                <StunningCard />
            </section>
            <div className="kerjasama">
                    <h1>
                        Kerjasama Lembaga:
                    </h1>
                    <Ticker />
                </div>
        </>

    )
}
